const ASK_AI_SELECTOR = '.ask-ai';
const HERO_HOME_SELECTOR = '.hero-home';
const VISIBLE_CLASS = 'ask-ai--visible';

export const initAskAiVisibility = () => {
  const askAiElement = document.querySelector(ASK_AI_SELECTOR);
  const heroElement = document.querySelector(HERO_HOME_SELECTOR);

  if (!(askAiElement instanceof HTMLElement)) {
    return;
  }

  const setVisible = (isVisible) => {
    askAiElement.classList.toggle(VISIBLE_CLASS, isVisible);
    askAiElement.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    askAiElement.setAttribute('tabindex', isVisible ? '0' : '-1');
  };

  if (!(heroElement instanceof HTMLElement)) {
    setVisible(true);
    return;
  }

  const syncVisibility = () => {
    const heroBottom = heroElement.getBoundingClientRect().bottom;
    const hasPassedHero = heroBottom <= 0;

    setVisible(hasPassedHero);
  };

  syncVisibility();
  window.addEventListener('scroll', syncVisibility, { passive: true });
  window.addEventListener('resize', syncVisibility);
};
